module.exports = __webpack_public_path__ + "static/media/services.52bb0847.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services.jpg
// module id = 836
// module chunks = 0